import { CUSTLOGTYPE_INIT_LOADING, CUSTLOGTYPE_INIT_SUCCESS, CUSTLOGTYPE_INIT_FAIL, CUSTLOGTYPE_COMMIT_KEY } from '@/store/types'
import http from '@/utils/ajax'
import clone from 'clone'
import { extractMenu, extractMessages } from '@/utils/extract'

export const initialState = {
  init: 0,
  initErr: [],
  menu: {},
  logType: {
    logTypeId: {
      logType: null,
      logTypeDesc: null,
      permitUw: null,
      permitCl: null
    }
  }
}

const getters = {

}

const mutations = {
  [CUSTLOGTYPE_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [CUSTLOGTYPE_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data.menu
    state.initErr = []
  },
  [CUSTLOGTYPE_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  },
  [CUSTLOGTYPE_COMMIT_KEY](state, data) {
    state.logType.logTypeId.logType = data.logType
    state.logType.logTypeId.logTypeDesc = data.logTypeDesc
    state.logType.logTypeId.permitUw = data.permitUw
    state.logType.logTypeId.permitCl = data.permitCl
    state.logType.logTypeId.tranMode = data.tranMode
  }
}

const actions = {
  async custLogTypeManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.custLogTypeManagement
    commit(CUSTLOGTYPE_INIT_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(CUSTLOGTYPE_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(CUSTLOGTYPE_INIT_FAIL, extractMessages(error))
      }
    }
  }
}

export default {
  state: clone(initialState),
  getters,
  mutations,
  actions
}
